export const tooltipTokens = {
    colorScheme: {
        light: {
            root: {
                background: '{navy.700}',
                color: '{white}',
                padding: '0.125rem 0.25rem',
                borderRadius: '0.125rem',
            },
        }
    },
    css: () => `
        .p-tooltip-text {
            font-size: 0.625rem;
            font-weight: 600;
            line-height: 1.2;
            letter-spacing: 0.1px;
            white-space: nowrap;
        }
    `,
};
